import type { NodePositions, NodeRecord } from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import { record } from 'fp-ts';
import { pipe } from 'fp-ts/lib/pipeable';
import {
  type HydratedCollapsedNodeGroups,
  collapsedNodeGroupIdFromNode,
} from '../model/GraphData';
import { getCollapsedNodePositions } from './getCollapsedNodePositions';

const getNodePositionsFromRecord = (nodes: NodeRecord): NodePositions => {
  const nodePositions: NodePositions = {};
  for (const nodeData of Object.values(nodes)) {
    // set property instead of slow object copy every iteration
    nodePositions[nodeData.sn] = {
      x: nodeData.position.x,
      y: nodeData.position.y,
    };
  }
  return nodePositions;
};

export const getNodePositions = (
  nodes: NodeRecord,
  collapsedNodeGroups: HydratedCollapsedNodeGroups,
): NodePositions => {
  const uncollapsedNodePositions = pipe(
    nodes,
    record.filter(
      (node) =>
        !!node && !collapsedNodeGroups[collapsedNodeGroupIdFromNode(node.id)],
    ),
    getNodePositionsFromRecord,
  );

  return {
    ...uncollapsedNodePositions,
    ...getCollapsedNodePositions(collapsedNodeGroups, nodes),
  };
};

export const getNodePositionsFromState = (state: GraphState): NodePositions =>
  getNodePositions(state.graph.nodes, state.graph.collapsedNodeGroups);
